import Vue from 'vue';
import Captcha from '@telexpress/vue-captcha';

Vue.use(Captcha, {
  domain: Vue.env.VUE_APP_Captcha_DOMAIN
});
